import { jsx as _jsx } from "react/jsx-runtime";
import { BlockWithAlignableContents } from '@lexical/react/LexicalBlockWithAlignableContents';
import { DecoratorBlockNode } from '@lexical/react/LexicalDecoratorBlockNode';
function convertTweetElement(domNode) {
    const id = domNode.getAttribute('data-lexical-tweet-id');
    if (id) {
        const node = $createTweetNode(id);
        return { node };
    }
    return null;
}
export class TweetNode extends DecoratorBlockNode {
    static getType() {
        return 'tweet';
    }
    constructor(id, format, key) {
        super(format, key);
        this.__id = id;
    }
    static clone(node) {
        return new TweetNode(node.__id, node.__format, node.__key);
    }
    static importJSON(serializedNode) {
        return $createTweetNode(serializedNode.id).updateFromJSON(serializedNode);
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            id: this.getId(),
        };
    }
    static importDOM() {
        return {
            div: (domNode) => {
                if (!domNode.hasAttribute('data-lexical-tweet-id')) {
                    return null;
                }
                return {
                    conversion: convertTweetElement,
                    priority: 2,
                };
            },
        };
    }
    exportDOM() {
        const element = document.createElement('div');
        element.setAttribute('data-lexical-tweet-id', this.__id);
        const text = document.createTextNode(this.getTextContent());
        element.append(text);
        return { element };
    }
    getId() {
        return this.__id;
    }
    getTextContent(_includeInert, _includeDirectionless) {
        return `https://x.com/i/web/status/${this.__id}`;
    }
    decorate(_, config) {
        const embedBlockTheme = config.theme.embedBlock || {};
        const className = {
            base: embedBlockTheme.base || '',
            focus: embedBlockTheme.focus || '',
        };
        const link = this.getTextContent();
        return (_jsx(BlockWithAlignableContents, { className: className, format: this.__format, nodeKey: this.getKey(), children: _jsx("a", { href: link, target: "_blank", rel: "noreferrer noopener", children: link }) }));
    }
    isInline() {
        return false;
    }
}
export function $createTweetNode(tweetID) {
    return new TweetNode(tweetID);
}
export function $isTweetNode(node) {
    return node instanceof TweetNode;
}
